import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import usePage from '@/hooks/use-page'
import { useNavigate, useLocation, useParams } from '@/lib/router-dom'
import { getUseCaseId } from "@/utils/use-case-storage"
import { useMemo, useState } from 'react'

const Page = () => {

	/*=================================================
		General
	/================================================*/

	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const [pageTitle, setPageTitle] = useState('Success')
	const [subPageTitle, setSubPageTitle] = useState(useCase.name)

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Dashboard', subPageTitle, 'Initiate Data Element Sharing'] })

	const types = {
		provider: "provider",
		noProvider: "no-provider",
	}

	const { goTo } = useNavigate()
	const { currentState } = useLocation()


	const data = currentState

	/*=================================================
		Navigate
	/================================================*/

	function backToDashboard() {
		goTo(`/use-cases/${useCaseId}/dashboard`)
	}

	function backToDataElementDetails() {
		goTo(`/use-cases/${useCaseId}/data-elements/${data.dataElement.dataElementId}/${data.enrolmentType}`)
	}

	return (
		<>
			<div className="layout-feedback">
				<div className="layout-feedback__header layout-feedback__center">
					{
						data.type === types.noProvider && (
							<>
								Pitstop has been successfully added
							</>
						)
					}

					{
						data.type === types.provider && (
							<>
								A request has been sent to the <br/>
								nominated pitstop(s) for their approval
							</>
						)
					}
				</div>

				<div className="layout-feedback__content">
					<img src="/img/success.png" />
				</div>

				<div className="layout-feedback__footer">
					<Button sizing='Medium' text="Back to Use Case Dashboard" round ghost
						submit={() => backToDashboard()}
					/>

					<Button sizing='Medium' text="Back to Data Element Details" round
						submit={() => backToDataElementDetails()}
					/>
				</div>
			</div>

		</>
	)
}
export default Page
